type TerraformValidationStepStatus = 'success' | 'failed' | 'pending'

export type { TerraformValidationStepStatus }

export const TERRAFORM_VALIDATION_STEPS: {
  label: string
  status: TerraformValidationStepStatus
  errorTitle: string
  errorMessage: string
}[] = [
  {
    label: 'IAM role/ Platform role ARN has been created successfully.',
    status: 'pending',
    errorTitle: 'IAM role validation failed',
    errorMessage:
      'Unable to assume the IAM role. Review IAM role configuration',
  },
  {
    label: 'Access to the S3 bucket has been granted.',
    status: 'pending',
    errorTitle: 'S3 bucket validation failed',
    errorMessage:
      'Unable to access the specified S3 bucket. Review S3 bucket configuration',
  },
  {
    label: 'Eventbridge implemented',
    status: 'pending',
    errorTitle: '',
    errorMessage: '',
  },
]
